// Menu icon

// Icon menu metrics
let menuIconCloseWidth = 24.957;
let menuIconOpenWidth = 20;
let menu = document.querySelector(".menu");
let menuIconButton = document.querySelector(".menu-icon");

let closeAllMenu = (e) => {
  let menuText = menuIconButton.querySelector(".menu-icon__text");
  let menuMobileContainer = document.querySelector(".navigation-mobile");

  let filterElement = document.querySelector(".filter");
  let searchElement = document.querySelector(".search");

  if (e.classList.contains("open")) {
    menuText.textContent = "Menu";
    menu.classList.remove("open");
    menuMobileContainer.classList.remove("menu-active");
    menuMobileContainer.classList.remove("search-active");
    searchElement.classList.remove("open");
    menuMobileContainer.classList.remove("open");
    document.body.classList.remove("body-hidden-any-device");
    document.body.classList.remove("body-hidden-filter");
    document.body.classList.remove("body-hidden");

    try {
      filterElement.classList.remove("open");
    } catch (err) {
      console.log(err);
    }
  } else {
    menuText.textContent = "Close";
  }

  e.classList.toggle("open");
};

if (menu && menuIconButton) {
  menuIconButton.addEventListener("click", () => {
    closeAllMenu(menuIconButton);
  });
}
